var _linearGradient, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcNotificationShipping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "14.104%",
    x2: "85.896%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe16a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b78103"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.1110698 8.30009302h4.3585116c.3817736 0 .7460423.16013285 1.004093.44148838l3.5106977 3.8249302v4.8429768c0 .361502-.1435207.7082149-.3991412.9638355-.2556206.2556205-.6023335.3991412-.9638356.3991412h-1.0733023c0-1.3171606-1.0677696-2.3849302-2.3849302-2.3849302s-2.3849302 1.0677696-2.3849302 2.3849302h-1.6671628z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.163,
    cy: 18.772,
    fill: "#7a4f01",
    r: 2.385
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.1110698 12.5665116v6.2059535h-7.25860468c0-1.3173147-1.06789458-2.3852093-2.38520931-2.3852093-1.31731472 0-2.3852093 1.0678946-2.3852093 2.3852093h-1.70344186c-.36150206 0-.70821494-.1435207-.96383551-.3991412-.25562056-.2556206-.39914125-.6023335-.39914125-.9638355v-11.37934887c0-.36150206.14352069-.70821494.39914125-.9638355.25562057-.25562056.60233345-.39914126.96383551-.39914126h1.47851163c.08500164 2.4030825 2.05774024 4.30727527 4.46232558 4.30727527s4.37732394-1.90419277 4.46232554-4.30727527h1.9663256c.7527258 0 1.3629768.61025103 1.3629768 1.36297676z",
    fill: "#b78103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.7845581 4.51702326c0 .05023255-.0005581.10046511-.0027907.15013953-.0850016 2.40308248-2.0577402 4.30727525-4.46232554 4.30727525s-4.37732394-1.90419277-4.46232558-4.30727525c-.00223256-.04967442-.0027907-.09990698-.0027907-.15013953 0-2.46601563 1.99910065-4.46511628 4.46511628-4.46511628s4.46511624 1.99910065 4.46511624 4.46511628z",
    fill: "#74caff",
    stroke: "#74caff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.46697674 16.3875349c1.3171606 0 2.38493024 1.0677696 2.38493024 2.3849302s-1.06776964 2.3849302-2.38493024 2.3849302c-1.31716059 0-2.38493023-1.0677696-2.38493023-2.3849302 0-1.3171478 1.06778241-2.3849302 2.38493023-2.3849302z",
    fill: "#7a4f01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.8096186 6.30306977c-.09917416.00012442-.19465699-.03760557-.26695813-.10548837l-1.49023256-1.39534884c-.0788836-.07387832-.12362791-.17713235-.12362791-.2852093v-2.89562791c0-.21577637.17492131-.39069768.39069767-.39069768.21577637 0 .39069768.17492131.39069768.39069768v2.72651163l1.36654884 1.27953488c.11707405.10960812.15527467.27962928.09633971.42878338-.05893496.14915409-.20303407.2471236-.36340948.2471236z",
    fill: "#0c53b7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationShipping);
export default __webpack_public_path__ + "static/media/ic_notification_shipping.6e3f6f0458f7bb48599b699f533ec1e1.svg";
export { ForwardRef as ReactComponent };